import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { getCurrentMonthName, getLink } from "../../utils/helpers";
import { apiRequest } from "../../hooks/apiRequest";
import VisitasCard from "./Components/VisitasCard";
import Loader from "../general/Loader";
import { Link } from "react-router-dom";
import VisitasChart from "./Visitas/Components/VisitasChart";

const Salud = () => {
    const [anio, setAnio] = useState(parseInt(dayjs().format("YYYY")));
    const [mes, setMes] = useState(parseInt(dayjs().format("M")));
    const [canNext, setCanNext] = useState(false);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState();

    const months = Array.from({ length: 12 }, (_, i) => ({
        numero: i + 1,
        nombre: getCurrentMonthName(i),
    }));

    const anio_actual = parseInt(dayjs().format("YYYY"));
    const years = Array.from({ length: anio_actual - 2011 }, (_, i) => anio_actual - i);

    const getDashboard = async () => {
        setLoading(true);

        const {success, data} = await apiRequest({}, `salud/dashboard?year=${anio}&month=${mes}`, 'get');

        if (success) {
            setData(data);
        }

        setLoading(false);
    };

    const onFiltroChange = ({month, year}) => {
        // Si se coloca el mismo mes y año o hacer nada
        if (month == mes && year == anio) return;

        const currentYear = parseInt(dayjs().format("YYYY"));
        const currentMonth = parseInt(dayjs().format("M"));

        /** si el año-mes que se desea establecer es menor al actual setearlo. En caso contrario colocar el actual */
        if ((year * 100) + (month) < (currentYear * 100) + (currentMonth)) {
            setMes(month);
            setAnio(year);

            setCanNext(true);
        } else {
            setMes(currentMonth);
            setAnio(currentYear);

            setCanNext(false);
        }
	};

    const nextMonth = () => {
		if (mes === 12) {
			onFiltroChange({
                month: 1,
                year: anio + 1,
            });
		} else {
            onFiltroChange({
                month: mes + 1,
                year: anio,
            });
		}
	};

	const prevMonth = () => {
		if (mes === 1) {
            onFiltroChange({
                month: 12,
                year: anio - 1,
            });
		} else {
			onFiltroChange({
                month: mes - 1,
                year: anio,
            });
		}
	};

    useEffect(() => {
        getDashboard();
    }, [anio, mes]);

    return <div className="dashboard">
        <section className="dashboard-header">
            <span className="h2" style={{fontWeight: 700}}>
                <i className="fas fa-stethoscope text-primary"></i> <span className="text-primary">SAE</span> <span style={{color: "#444"}}>Salud</span>
            </span>

            <span className="h3 mx-auto" style={{color: "#444"}}>
                Estadísticas {getCurrentMonthName(mes - 1)} {anio}
            </span>

            <div className="dashboard-dates">
                <button
                    className="btn btn-primary"
                    onClick={prevMonth}
                >
                    <i className="zmdi zmdi-chevron-left"></i>
                </button>
                <select
                    name="mes"
                    value={mes}
                    onChange={(e) => onFiltroChange({month: parseInt(e.target.value), year: anio})}
                    className="form-control"
                >
                    {months.map((month) => (
                        <option key={month.numero} value={month.numero}>
                            {month.nombre}
                        </option>
                    ))}
                </select>
                <select
                    name="anio"
                    value={anio}
                    onChange={(e) => onFiltroChange({month: mes, year: parseInt(e.target.value)})}
                    className="form-control"
                >
                    {years.map((year) => (
                        <option key={year} value={year}>
                            {year}
                        </option>
                    ))}
                </select>
                <button
                    className="btn btn-primary"
                    onClick={nextMonth}
                    disabled={!canNext}
                >
                    <i className="zmdi zmdi-chevron-right"></i>
                </button>
            </div>
        </section>

        {loading ? <Loader /> : <>
            <div className="dashboard-cards-container" style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr 1fr 1fr",
                width: '100%',
                padding: 0,
                margin: "0 0 15px",
                rowGap: "10px",
                columnGap: "10px",
            }}>

                <VisitasCard data={data?.today} icon="fas fa-calendar-day" />

                <VisitasCard data={data?.current} icon="fas fa-calendar" />

                <VisitasCard data={data?.preview} icon="fas fa-calendar-minus" />

                <VisitasCard data={data?.all_time} icon="fas fa-history"/>
            </div>


            <div className="row">
                <div className="col-12 col-md-6" style={{minHeight: "100%"}}>
                    <div className="d-flex flex-column" style={{
                        minHeight: "100%",
                        borderRadius: "8px",
                        padding: "7px",
                        margin: "3px",
                        background: "white",
                    }}>
                        <span className="mx-2" style={{color: "#444", fontSize: "32px", fontWeight: 500}}>Visitas Recientes</span>
                        <table className='table table-data2 mb-2'>
                            <thead>
                                <tr className="border-bottom">
                                    <th className="pb-1">Fecha</th>
                                    <th className="pb-1">Nombre</th>
                                    <th className="pb-1">Tipo</th>
                                    <th className="pb-1">Motivo</th>
                                </tr>
                            </thead>

                            <tbody>
                                {data?.visits.map(visita => <tr key={visita.id}>
                                    <td className="py-0 pr-2" style={{paddingLeft: "20px"}}>{dayjs(visita.fecha).format('DD/MM/YYYY')}</td>
                                    <td className="py-0 pr-2" style={{paddingLeft: "20px"}}>{visita.paciente.nombre_completo}</td>
                                    <td className="py-0 pr-2" style={{paddingLeft: "20px"}}>{visita.tipo}</td>
                                    <td className="py-0 pr-2" style={{paddingLeft: "20px"}}>{visita.motivo.descripcion}</td>
                                </tr>)}

                                {!data?.visits.length && <tr>
                                    <td className="text-center" colSpan={4}>No hay visitas recientes.</td>
                                </tr>}
                            </tbody>
                        </table>

                        <div className="row mt-auto pb-2">
                            <Link className="ml-auto mr-4" to={getLink('/salud/visitas')}>Ver más</Link>
                        </div>
                    </div>
                </div>

                <div className="col-12 col-md-6" style={{minHeight: "100%"}}>
                    <div className="d-flex flex-column" style={{
                        minHeight: "100%",
                        borderRadius: "8px",
                        padding: "7px",
                        margin: "3px",
                        background: "white",
                    }}>
                        <span className="mx-2" style={{color: "#444", fontSize: "32px", fontWeight: 500}}>Visitas Mensuales</span>

                       { !!data?.monthly.length && <VisitasChart data={data.monthly} /> }
                    </div>
                </div>
            </div>

        </>}
    </div>;
};

export default Salud;